import React from "react";

import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

import img1 from "../../logos/photos/Nicosia Risk Forum.png"
import img2 from "../../logos/photos/Nicosia Risk Forum_2.jpg"





export default function NRF2024() {

  
  return (
    <Layout>
      <Navbar  />
      <PageHeader />
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="about-content-left section-heading">
                <h3 style={{color:'#e95d04'}}>
                PANTHEON at the NRF2024
                                 </h3>
                <p>
                Between 4 and 5 December, the <a href='https://easyconferences.eu/nrf2024/'>Nicosia Risk Forum</a> (NRF2024) served as a meeting
point for interested parties from the disaster management and civil protection sectors.
This year, the focus was on steering discussions about potential solutions around
safety, security and the climate crisis in the Mediterranean region since the event's
central theme was “Strengthening the Disaster Resilience of the Mediterranean Region”.
</p>
<p>
The Nicosia Risk Forum was co-
organised by <a href='https://cerides.euc.ac.cy/'>The CERIDES – Center of
Excellence in Risk and Decision Sciences</a>
of the <a href='https://euc.ac.cy/en/'>European University of Cyprus</a> and
the <a href='https://www.presidency.gov.cy/cypresidency/cypresidency.nsf/home_en/home_en?openform'>Presidency of the Republic of Cyprus</a>.
It was also supported by <a href='https://www.google.com/url?sa=D&q=https://ufmsecretariat.org/&ust=1736345940000000&usg=AOvVaw2aqp23TNpo8dC_uwos5gX7&hl=en&source=gmail'>the Union for
the Mediterranean</a> and <a href='https://climpact.gr/main/'>the CLIMPACT
Panhellenic Initiative on Climate Change</a>.
Through our partner, <a href='https://kemea.gr/en/'>the Center for
Security Studies (KEMEA)</a>, the
PANTHEON project participated in the
event and discussions about the future of
the Mediterranean region. John
Tsaloukidis, a researcher at KEMEA, presented on the mission, technologies, use cases,
and Smart City Digital Twin (SCDT) architecture.</p>
<p>The audience’s response was positive, and the presentation steered discussions,
proving the importance of disaster risk management and the need for innovative
strategies, best practices, and actionable solutions.</p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="about-content-right">
                <img
                  src={img1}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />
                 <img
                  src={img2}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />

              </div>
            </div>
          </div>
        </div>
      </section>
  

      <Footer space />
    </Layout>
  );
}
